export default __webpack_public_path__ + "images/1473639fd272421f3eaa1af469ee081f-3_4K_1920x544.webp";